import { render, staticRenderFns } from "./RecommendActivity.vue?vue&type=template&id=7cf7ece4&"
import script from "./RecommendActivity.vue?vue&type=script&lang=js&"
export * from "./RecommendActivity.vue?vue&type=script&lang=js&"
import style0 from "./RecommendActivity.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports